export default __webpack_public_path__ + "static/media/cont.19efb333.jpg";